<template>
    <Portfolio class="card--portfolio-homepage" showTags="false" :isHome="true" :posts="filteredPosts" />
</template>

<script setup>

import Portfolio from "@/components/apps/card/Portfolio.vue";
import { useClientServiceStore } from "@/stores/clientService";

const store = useClientServiceStore();

const { fetchPortfolio } = useClientServiceStore();

await fetchPortfolio();

const { posts } = storeToRefs(store);

const filteredPosts = computed(() => {
    // กรองเฉพาะโพสต์ที่มีแท็ก Highlight
    const highlightPosts = posts.value.filter(post => post.categories.find((cat) => cat.name === "Highlight"));

    // เลือก 5 ตาม tags Highlight
    return highlightPosts.slice(0, 5);
});


</script>